import {
  FundListingController,
  FundListingType,
} from './fund-listing.controller';

export interface FundListingRatingsController extends FundListingController {
  fundListingType: FundListingType;
  ratingsAsOfDate?: string;
  hideRatingsToggle?: boolean;
  showCategory?: boolean;
  showViewDetails?: boolean;
}

export const isFundListingRatingsController = (
  object: any
): object is FundListingRatingsController =>
  object.fundListingType === FundListingType.RATINGS;
